import React, { useEffect, useState } from "react";
import LogoLayout from "../../../components/logolayout/logolayout";
import SelectInput from "../../../components/form/inputs/select-input/select-input";
import TextInput from "../../../components/form/inputs/text-input/text-input";
import {
  Navigate,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import {
  formatInputPrice,
  formatSiret,
  setNativeValue,
  sirenreg,
} from "../../../utils/utils";
import axiosInstance from "../../../config/axios";

export default function RegisterPrestatairePage() {
  const location = useLocation();
  let params = location.state;
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const email = searchParams.get("email");
  const role = searchParams.get("role");
  const token = searchParams.get("token");

  if (!params && email) {
    params = { email, role, token };
  }

  async function onSubmit(form: any) {
    form = { ...params, ...form };
    if (!form.lists) {
      form.lists = lists;
    }
    sessionStorage.setItem("email", form.email);
    sessionStorage.setItem("role", form.role);
    sessionStorage.setItem("token", form.token);
    sessionStorage.setItem("siret", form.siret);
    sessionStorage.setItem("capital", form.capital);
    sessionStorage.setItem("job", form.job);
    navigate("/register/prestataire/profil", { state: form });
  }

  useEffect(() => {
    setTimeout(() => {
      const values = {
        siret: sessionStorage.getItem("siret"),
        capital: sessionStorage.getItem("capital"),
        job: sessionStorage.getItem("job"),
      };
      if (values.siret && values.capital && values.job) {
        //query selector to fill the inputs
        const siret = document.getElementById("siret") as HTMLInputElement;
        const capital = document.getElementById("capital") as HTMLInputElement;
        const job = document.getElementById("job") as HTMLInputElement;
        if (siret && capital && job) {
          setNativeValue(siret, values.siret);
          setNativeValue(capital, values.capital);
          setNativeValue(job, values.job);
          const select = document.getElementById("job") as HTMLSelectElement;
          if (select) {
            select.value = "valeurASelectionner";
            // On déclenche un "change" (et non "input")
            select.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }
      }
    }, 100);
  }, []);

  const [lists, setLists] = useState<any>({});

  useEffect(() => {
    async function getLists() {
      try {
        const { data } = await axiosInstance.get("/datalists");
        setLists(data);
        const job = document.getElementById("job") as HTMLInputElement;
        setNativeValue(job, sessionStorage.getItem("job"));
      } catch (e) {
        console.log(e);
      }
    }
    getLists();
  }, []);

  const redirect = window.history.state.idx == 0 && !email;
  if (redirect) return <Navigate to={"/register"} replace />;

  return (
    <LogoLayout
      defaultValues={{ siret: "", capital: 12, job: "" }}
      params={params}
      onSubmit={onSubmit}
      progress={30}
    >
      <h1>Inscription</h1>
      <p className="subtitle">{params.role}</p>
      <h2 className="title">Mes informations</h2>
      <div>
        <TextInput
          validate={(val: any) =>
            !sirenreg.test(val?.replaceAll(" ", "")) ? "SIRET invalide" : true
          }
          maxLength={17}
          name="siret"
          format={formatSiret}
          placeHolder="000 000 000 00000"
          label="SIRET"
        />
        <TextInput
          validate={(val: any) =>
            val && isNaN(val) ? "Capital social invalide" : true
          }
          name="capital"
          format={formatInputPrice}
          rightIcon={
            <span
              style={{ fontSize: 16, fontFamily: "Rubik", color: "#81898d" }}
            >
              €
            </span>
          }
          placeHolder="0 "
          label="Capital social"
        />
        {lists?.Jobs && (
          <SelectInput
            placeHolder="Choix de la profession"
            required="Profession invalide"
            name="job"
            options={lists?.Jobs?.map((elt: any) => {
              return { label: elt, value: elt };
            })}
            label="Profession"
          />
        )}
      </div>
    </LogoLayout>
  );
}
